module.exports = __webpack_public_path__ + "static/marc-doodle-9d6d4d133eb13893ff00d678ba47560b.svg";